import React from 'react'
import { StyleService, useStyleSheet } from '@src/style/service'
import { ContentLoader, Rect } from '@src/components/ContentLoader'

export const VideoCallContentLoader = () => {
  const styles = useStyleSheet(themedStyles)

  return (
    <ContentLoader style={styles.loader}>
      <Rect x="0" y="0" width="160" height="24" rx="6" ry="6" />
      <Rect x="100%" y="0" width="100" height="24" translateX="-100" rx="12" ry="12" />

      <Rect x="0" y="32" width="38%" height="18" rx="6" ry="6" />
      <Rect x="0" y="54" width="32%" height="18" rx="6" ry="6" />
      <Rect x="0" y="76" width="50%" height="18" rx="6" ry="6" />

      <Rect x="0" y="114" width="92%" height="14" rx="6" ry="6" />
      <Rect x="0" y="136" width="98%" height="14" rx="6" ry="6" />
      <Rect x="0" y="158" width="40%" height="14" rx="6" ry="6" />

      <Rect x="0" y="194" width="100%" height="8" rx="0" ry="0" />

      <Rect x="12" y="226" width="24" height="24" rx="6" ry="6" />
      <Rect x="48" y="226" width="40%" height="24" rx="6" ry="6" />

      <Rect x="12" y="286" width="24" height="24" rx="6" ry="6" />
      <Rect x="48" y="286" width="60%" height="24" rx="6" ry="6" />

      <Rect x="12" y="348" width="24" height="24" rx="6" ry="6" />
      <Rect x="48" y="348" width="50%" height="24" rx="6" ry="6" />
    </ContentLoader>
  )
}

const themedStyles = StyleService.create({
  loader: {
    marginTop: 6,
    height: 374,
  },
})
